<template>
  <div>
    <div class="footer">
      <div class="footer-nav">
        <div>
          <router-link to="Ahome">
            <div style="color:white">{{home}}</div>
          </router-link>
        </div>
        <div>
          <el-dropdown trigger="click">
            <span class="el-dropdown-link">
              {{service}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <div>
                  <div style="color:black" @click="routerdetails(600)">{{service1}}</div>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div>
                  <div style="color:black" @click="routerdetails(1000)">{{service2}}</div>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div>
                  <div style="color:black" @click="routerdetails(1400)">{{service3}}</div>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div>
                  <div style="color:black" @click="routerdetails(1800)">{{service4}}</div>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div>
          <router-link to="Ainnovate">
            <div style="color:white">{{innovate}}</div>
          </router-link>
        </div>
        <div>
          <router-link to="Anew">
            <div style="color:white">{{news}}</div>
          </router-link>
        </div>
        <div>
          <router-link to="Aabout">
            <div style="color:white">{{about}}</div>
          </router-link>
        </div>
        <div>
          <router-link to="Ajoin">
            <div style="color:white">{{join}}</div>
          </router-link>
        </div>
      </div>
      <div class="footer-about">
        <div class="contact">
          <div class="contact-div">{{ci}}</div>
          <div :class=" ischinese == 'cn' ?'contact-details contact-detailsss':'contact-details'">
            <div class="divtel">{{ci1}}：{{ischinese == "cn" ?this.address:this.address_en}}</div>
            <div>{{ci2}}：{{this.tel}}</div>
          </div>
          <div class="contact-details">
            <div>{{ci3}}：{{this.email}}</div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <span>
          Copyright {{this.year}} 深圳前海融森科技有限公司版权所有 |
          <a
            style="color:#ffffff"
            href="http://www.beian.miit.gov.cn"
          >粤IPC备18131974号</a> Powered By <a style="color:white;" href="http://www.xiaoxxx.com/">小仙科技</a>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Btfooter",
  data() {
    return {
      tel: "",
      address: "",
      address_en: "",
      email: "",
      year: "",

      ischinese: "cn",
      home: "首页",
      service: "我们的服务",
      service1: "品牌代运管理",
      service2: "多模式渠道管理",
      service3: "供应链管理",
      service4: "数据管理",
      innovate: "创新",
      news: "新闻中心",
      about: "关于我们",
      join: "加入我们",
      ci: "联系方式",
      ci1: "地址",
      ci2: "电话",
      ci3: "邮箱"
    };
  },
  methods: {
    getList() {
      this.$http
        .post("/api/dashu/footer/footerList", {})
        .then(res => {
          // console.log(res)
          var code = res.data.code;
          if (code === 0) {
            this.tel = res.data.data.about.telphone;
            this.address = res.data.data.about.address;
            this.address_en = res.data.data.about.address_en;
            this.email = res.data.data.about.email;
          }
        })
        .catch(function(error) {
          //  console.log(error);
        });
    },
    routerdetails(topnum) {
      this.$router.push({
        name: "Aservice",
        query: { topnum: topnum }
      });
    }
  },
  created() {
    this.getList();
    var now = new Date();
    var year = now.getFullYear(); //获取当前年份
    this.year = year;

    this.ischinese = window.localStorage.getItem("ischinese") || "cn";
    if (this.ischinese == "en") {
      this.home = "HomePage";
      this.service = "OurServices";
      this.service1 = "BrandTransportationManagement";
      this.service2 = "Multi-modeChannelManagement";
      this.service3 = "SupplyChainManagement";
      this.service4 = "DataManagement";
      this.innovate = "Innovation";
      this.news = "InformationCenter";
      this.about = "AboutUs";
      this.join = "JoinUs";
      this.ci = "Contact information";
      this.ci1 = "Address";
      this.ci2 = "Tel";
      this.ci3 = "Email";
    }
  }
};
</script>
<style scoped>
.footer {
  border-top: 15px solid #76c3a2;
  background: #2e3231;
  margin: 0 auto;
  width: 100%;
  min-width: 1200px;
  /* height: 476px; */
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  padding-bottom: 20px;
}
.footer-nav {
  width: 50%;
  margin: 0 15%;
  padding: 3% 10% 84px;
  color: white;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
}
.footer-about {
  width: 50%;
  margin: 0 15%;
  padding: 2% 10%;
  color: white;
  display: flex;
  justify-content: space-between;
}
.footer-bottom {
  width: 50%;
  margin: 0 15%;
  padding: 1% 10%;
  color: white;
}
.footer-bottom {
  text-align: center;
}
.contact {
  width: 100%;
}
.contact-div {
  /* font-size: 1.2vw; */
  padding-bottom: 40px;
}
/* .contact-details { */
  /* display: flex; */
/* } */

.contact-detailsss {
  display: flex;
}
.contact-details div {
  width: 50%;
  padding-bottom: 30px;
  white-space: nowrap;
}
.divtel {
  margin-right: 155px;
}
.el-dropdown-link {
  cursor: pointer;
  color: white;
  font-size: 16px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/dashu/footer.vue